import React from 'react';
import './ImagePreviewCarousel.css';

interface ImagePreviewCarouselProps {
  thumbnails: string[];
  onSelect: (imageUrl: string) => void;
  onMoveUp: (index: number) => void;
  onMoveDown: (index: number) => void;
  onRemove: (index: number) => void;
}

const ImagePreviewCarousel: React.FC<ImagePreviewCarouselProps> = ({ thumbnails, onSelect, onMoveUp, onMoveDown, onRemove }) => {
  return (
    <div className="thumbnails">
      {thumbnails.map((thumbnail, index) => (
        <div key={index} className="thumbnail-item">
          <div className="arrow-buttons">
            <button onClick={() => onMoveUp(index)}>↑</button>
            <button onClick={() => onMoveDown(index)}>↓</button>
          </div>
          <img
            src={thumbnail}
            alt={`Thumbnail ${index + 1}`}
            onClick={() => onSelect(thumbnail)}
            className="thumbnail"
          />
          <button className="remove-button" onClick={() => onRemove(index)}>X</button>
        </div>
      ))}
    </div>
  );
};

export default ImagePreviewCarousel;
